module.exports = __webpack_public_path__ + "static/media/中巴地球资源卫星04星.66bb3a9a.png";